import { typographyClasses } from "@mui/material";
import { typography } from "../typography/typography.js";
import "../typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../typography/utils/typographyVariants/typographyVariants.js";
const MuiPickersToolbar = {
  styleOverrides: {
    root: ({ theme }) => ({
      borderBottom: `1px solid ${theme.palette.grey["300"]}`,
      [`span.${typographyClasses.root}`]: {
        ...typography["Lato Caption Bold"],
        color: theme.palette.grey["800"],
        textTransform: "unset"
      }
    }),
    content: {
      marginTop: "40px"
    }
  }
};
export {
  MuiPickersToolbar
};
